// ============================================================================
// INTELLISPOT ONTOLOGY NAMESPACES
// ============================================================================

export const NAMESPACES = {
  // Intellispot ontology namespaces
  io: 'http://www.intellispot.com/ontology#',
  core: 'http://www.intellispot.com/ontology#', // Core uses main io namespace
  market: 'http://www.intellispot.com/ontology/market#',
  business: 'http://www.intellispot.com/ontology/business#',
  solution: 'http://www.intellispot.com/ontology/solution#',
  canvas: 'http://www.intellispot.com/ontology/canvas#',

  // Standard namespaces
  rdf: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
  rdfs: 'http://www.w3.org/2000/01/rdf-schema#',
  owl: 'http://www.w3.org/2002/07/owl#',
  xsd: 'http://www.w3.org/2001/XMLSchema#',
  skos: 'http://www.w3.org/2004/02/skos/core#',

  // External ontologies
  fibo: 'https://spec.edmcouncil.org/fibo/ontology/',
} as const

export type NamespacePrefix = keyof typeof NAMESPACES

export const SPARQL_PREFIXES = Object.entries(NAMESPACES)
  .map(([prefix, uri]) => `PREFIX ${prefix}: <${uri}>`)
  .join('\n')

export function expandPrefix(prefixedUri: string): string {
  const [prefix, localName] = prefixedUri.split(':')
  const namespace = NAMESPACES[prefix as NamespacePrefix]
  if (namespace) {
    return `${namespace}${localName}`
  }
  return prefixedUri
}

export function compactUri(fullUri: string): string {
  for (const [prefix, namespace] of Object.entries(NAMESPACES)) {
    if (fullUri.startsWith(namespace)) {
      return `${prefix}:${fullUri.slice(namespace.length)}`
    }
  }
  return fullUri
}

export function getLocalName(uri: string): string {
  const hashIndex = uri.lastIndexOf('#')
  const slashIndex = uri.lastIndexOf('/')
  const index = Math.max(hashIndex, slashIndex)
  return index >= 0 ? uri.slice(index + 1) : uri
}

export function getDomainFromUri(uri: string): 'core' | 'market' | 'business' | 'solution' | null {
  if (uri.includes('/market#') || uri.includes('Market')) return 'market'
  if (uri.includes('/business#') || uri.includes('Business')) return 'business'
  if (uri.includes('/solution#') || uri.includes('Solution')) return 'solution'
  // Core classes use the main ontology namespace
  if (uri.includes('Facet') || uri.includes('Source')) return 'core'
  return null
}
